import { useParams } from 'react-router';
import { GiftCertificateCreateView } from './components/GiftCertificateCreateView.js';
import { GiftCertificateDetailView } from './components/GiftCertificateDetailView.js';

export function GiftCertificateFormPage() {
  const { id } = useParams();
  return id ? <GiftCertificateDetailView id={id} /> : <GiftCertificateCreateView />;
}
